import Vue from 'vue'
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        enterClassName: 'animated fadeIn',
        leaveClassName: 'animated fadeOut',
        enterClassNameLoader: 'animated fadeIn',
        leaveClassNameLoader: 'animated fadeOut',
        enterClassNameWork: 'animated fadeIn',
        leaveClassNameWork: 'animated fadeOut',
        player: null,
        loader: false,
        loaderVisible: false,
        mainLoader: true,
        mainLoaderVisible: true,
        mainLoaderEnable: true,
        //apiUrl: 'https://s1.webwalks.ru/api/api.php',
        apiUrl: '/api/api.php',
        pageLoaded: false,
        pagesLoaded: {},
        pages: {},
        mapFullScreen: false,
        menuHidden: false,
        hiddenMobileMenuBtn: false,
    },
    mutations: {
        initPreloader(state, data) {
            state.player = data.player;

            //state.player.stop();
        },
        loaderON(state) {
          state.loader = true;
          setTimeout(function () {
            state.loaderVisible = true;
          }, 100);
        },
        loaderOFF(state) {
          state.loaderVisible = false;
          setTimeout(function () {
            state.loader = false;
          }, 400);
        },
        mainLoaderON(state) {
            state.mainLoader = true;
            setTimeout(function () {
                state.mainLoaderVisible = true;
            }, 100);
        },
        mainLoaderOFF(state) {
            state.mainLoaderVisible = false;
            setTimeout(function () {
                state.mainLoader = false;

              setTimeout(function () {
                state.mainLoaderEnable = false;
              }, 400);
            }, 400);
        },
        pageLoaded: function (state, params) {
            state.pageLoaded = true;

            state.pagesLoaded[params.page] = true;
        },
        toggleMapFullScreen(state) {
          state.mapFullScreen = !state.mapFullScreen;
        },
        toggleMenu(state) {
          state.menuHidden = !state.menuHidden;
        },
        toggleMobileMenuBtn(state) {
            state.hiddenMobileMenuBtn = !state.hiddenMobileMenuBtn;
        },
        showMobileMenuBtn(state) {
          state.hiddenMobileMenuBtn = false;
        },
        hideMobileMenuBtn(state) {
          state.hiddenMobileMenuBtn = true;
        },
        hideMenu(state) {
          state.menuHidden = true;
        },
        showMenu(state) {
          state.menuHidden = false;
        },
    },
    actions: {
        async loadData ({ commit, state }, params) {

            let response = await axios.get(state.apiUrl,{
                params: {
                    action: 'loadData',
                    page: params.page
                }
            });

            let data = response.data.data;

            Vue.set(state.pages, params.page, data);

            commit('pageLoaded', params);
        },
    }
});

export default store;



// WEBPACK FOOTER //
// ./src/store.js